module.exports = __webpack_public_path__ + "img/wpexplorer.459fe605.svg";